import React from 'react';

const Process = () => {
  const steps = [
    { id: '01', title: "Discovery", desc: "Conceptualize & shape your idea", color: "border-orange-300 text-orange-400 bg-orange-400" },
    { id: '02', title: "Design", desc: "Architecture & tech stack selection", color: "border-red-300 text-red-400 bg-red-400" },
    { id: '03', title: "Prototype", desc: "Iterative MVP development", color: "border-cyan-300 text-cyan-400 bg-cyan-400" },
    { id: '04', title: "Build", desc: "Full development & testing", color: "border-pink-300 text-pink-400 bg-pink-400" },
    { id: '05', title: "Deploy", desc: "DevOps, automation & go-live", color: "border-blue-300 text-blue-400 bg-blue-400" },
    { id: '06', title: "Support", desc: "Monitoring & scaling", color: "border-green-300 text-green-400 bg-green-400" },
  ];

  return (
    <section className="pt-0 pb-6 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-slate-800 mb-16 text-center">Our Process</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-12">
          {steps.map((step, index) => (
            <div key={step.id} className="relative flex flex-col items-center text-center group">
              
              {/* Connecting Line (Desktop Only) */}
              {index !== steps.length - 1 && (
                <div className="absolute left-[70%] top-16 w-full h-[2px] bg-gray-200 z-0 hidden lg:block"></div>
              )}

              {/* Multi-Layer Circle Design (From Image 1) */}
              <div className={`relative z-10 flex items-center justify-center w-32 h-32 rounded-full border-2 ${step.color.split(' ')[0]} p-1.5 mb-6 bg-white transition-transform duration-300 group-hover:-translate-y-2`}>
                
                {/* Middle Thick Ring */}
                <div className={`w-full h-full rounded-full flex items-center justify-center ${step.color.split(' ')[2]} bg-opacity-20 p-2`}>
                  
                  {/* Inner White Circle */}
                  <div className="w-full h-full bg-white rounded-full flex flex-col items-center justify-center shadow-md">
                    <span className="text-2xl font-bold text-slate-700 leading-none">{step.id}</span>
                  </div>
                </div>
              </div>

              {/* Content (From Image 2) */}
              <h3 className={`text-lg font-bold mb-2 ${step.color.split(' ')[1]}`}>
                {step.title}
              </h3>
              <p className="text-gray-500 text-xs leading-relaxed px-2">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;